var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.disabledNosupported && !_vm.url)?_c('div',[_c('span',[_vm._v(_vm._s(_vm.supportedTip))])]):_c('div',[(_vm.url)?_c('img',{staticClass:"cover",style:({ width: _vm.w, height: _vm.h }),attrs:{"src":_vm.url}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }